import styled from "styled-components";

export const CheckboxTreeWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CheckboxTreeActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

export const CheckboxTreeNode = styled.div`
  position: relative;
  margin-bottom: 5px;
`;

export const CheckboxTreeLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const CheckboxTreeInput = styled.input`
  margin: 0;
`;


export const LabelText = styled.label`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: var(--text-color-primary);
  margin: 0 !important;

  .dark-mode & {
    color: var(--text-color-primary);
  }

  svg {
    width: 16px;
    height: auto;
    color: var(--theme-color-primary);
  }
`;

export const ExpandIcon = styled.span`
  width: 20px;
  height: 20px;
  cursor: pointer;

  svg {
    width: 100%;
    height: auto;
    transition: transform 0.2s ease-in-out;

    &.checkbox-tree-expand {
      transform: rotate(90deg);
    }
  }
`;

export const CheckboxTreeChildren = styled.div`
  margin-left: 44px;
  position: relative;
`;